import { HelpersBrokenIFrame } from './helpers-broken-iframe.js';
import { HelpersHTMLWin } from './helpers-html-win.js';
import { HelpersUserJavascript } from './helpers-user-javascript.js';
import { HelpersElement } from './helpers-element.js';
import { HelpersLinkFixer } from './helpers-link-fixer.js';
import { HelpersDOM } from './helpers-dom.js';
import { HelpersFixers } from './helpers-fixers.js';


export function Helpers (pEditor)
{
  const winLocationHref = pEditor.$winContent.location.href;

  Object.defineProperty(this, 'winLocationHref', { get: () => winLocationHref});

  this.brokenIFrame = new HelpersBrokenIFrame(pEditor, this);
  this.htmlWin = new HelpersHTMLWin(pEditor, this);
  this.userJavascript = new HelpersUserJavascript(pEditor, this);
  this.element = new HelpersElement(pEditor, this);
  this.linkFixer = new HelpersLinkFixer(pEditor, this);
  this.dom = new HelpersDOM(pEditor, this);
  this.fixers = new HelpersFixers(pEditor, this);


  this.reInit = () =>
  {
    this.brokenIFrame.reInit();
  };


  this.insertHTML = (stringToInsert) =>
  {
    let currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      currentRange.deleteContents();
      pEditor.contentCleaner.removeEmptyP();
      currentRange.insertNode(currentRange.createContextualFragment(stringToInsert));

      pEditor.range.save();
    }
  };


  const restoreEditorEntitiesDo = () =>
  {
    pEditor.layer.objectFactory.fixAllAbsElements();
    pEditor.image.objectFactory.checkAllImages();
    pEditor.anchor.reCollectAnchors();
    this.fixers.fixGeckoAlign();
    this.fixers.setFixGeckoTables({isFix: true});
  };


  this.restoreEditorEntities = () =>
  {
    setTimeout(restoreEditorEntitiesDo, 11);
  };


  this.isArrayIncludes = (arr, item) =>
  {
    if ('includes' in arr)
    {
      return arr.includes(item);
    }
    else
    {
      for (let i = 0; i < arr.length; i++)
      {
        if (arr[i] === item)
        {
          return true;
        }
      }

      return false;
    }
  };
}